import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { checkTokenValidity } from "services/authServices/authServices";
import { ResetPasswordForm } from "../../../components/auth/resetPassword/resetPasswordForm";
import { SendEmail } from "../../../components/auth/resetPassword/sendEmail";
import { AuthLayout } from "../../../layouts/auth/authLayout";
import { useAuthStore } from "hooks/useAuthStore";

export const ResetPasswordScreen = () => {
  const [urlSearchParams] = useSearchParams();
  const [mode, setMode] = useState("loading");
 const {changeSeccionSelect } = useAuthStore(); 
  useEffect(() => {
    
    document.title = "Restablecer Contraseña";
    changeSeccionSelect(1);
    if (urlSearchParams.has("t")) {
      checkTokenValidity({
        token: urlSearchParams.get("t"),
      })
        .then(() => {
          setMode("reset");
        })
        .catch(() => {
          setMode("email");
        });
    } else {
      setMode("email");
    }//eslint-disable-next-line
  }, []);
//eslint-disable-next-line
  if (mode == "reset") {
    return (
      <AuthLayout title="Restablecer Contraseña">
        <ResetPasswordForm token={urlSearchParams.get("t")} />
      </AuthLayout>
    );
  }
//eslint-disable-next-line 
  if (mode == "email") {
    return (
      <AuthLayout title="Restablecer Contraseña">
        <SendEmail />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Restablecer Contraseña">
      <Typography variant="h4">Cargando...</Typography>
    </AuthLayout>
  );
};
